import React from 'react';
import { withStyles, Grid, ButtonBase, Dialog, Box, Zoom, } from '@material-ui/core';
import AppData from '../../../model/AppData';
import AppUtils from '../../../control/apputlis';

const ICON_SHARE_DOWN = require("../../../images/change/download.png");
const ICON_SHARE_BUTTON = require("../../../images/change/download_btn.png");
const ICON_CLOSE = require("../../../images/bg/guanbi_icon.png");

class Download extends React.Component {

    constructor() {
        super();
        this.state = {
            show: true,
        }
    }
    componentDidMount() {
        if (AppData.ShareUrl == '') {
            AppData.getShareConfig()
        }

    }

    _isIos = () => {
        var u = navigator.userAgent;
        if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
            return true;
        }
        return false;
    }

    _onDownload = () => {
        AppUtils.openUrl(AppData.ShareUrl);
        AppUtils.YMPush('DOWNLOAD', 'downloadapp');
    }

    onClose = (e) => {
        e.stopPropagation();
        this.setState({ show: false })
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    render() {
        const { classes } = this.props;
        const { show } = this.state;
        if (!show) {
            return (
                <div></div>
            );
        }
        return (
            <Dialog open={this.state.show} classes={{}}>
                <Box sx={{ display: 'flex' }}>
                    <Zoom in={this.state.show} style={{ transitionDelay: this.state.showDiaLog ? '0ms' : '0ms' }}>
                        <div className='dialogBox'>
                            <Grid container justifyContent='center' style={{ width: '100%', position: 'relative' }} >
                                <img src={ICON_SHARE_DOWN} onClick={() => this._onDownload()} className={classes.img} />
                                <img src={ICON_SHARE_BUTTON} onClick={() => this._onDownload()} className={classes.downbtn} />
                            </Grid>
                            <img src={ICON_CLOSE} style={{ width: 26, height: 26, marginTop: 32 }} onClick={(e) => this.onClose(e)} />
                        </div>
                    </Zoom>
                </Box>
            </Dialog>
        );
    }
}


export default withStyles((theme) => ({
    downbtn: {
        width: '18rem',
        marginTop: 20
    },
    img: {
        width: '80vw',
        height: '86.89vw'
    }

}))(Download);